import { __getInstance__ } from './instance';

function getInstance(): MatrixInstance {
    return __getInstance__();
}

export {
    getInstance
};
